export default __webpack_public_path__ + "static/media/carosel (1).823cd4f2.jpg";